export default __webpack_public_path__ + "static/media/logo22.815d0563.png";